import axios from 'axios';

export default {
    async login(email, password) {
        return new Promise((resolve, reject) => {
            axios.post('/api/users/login', {
                email, password,
            }).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },
};
